import HtmlTooltip from '@sophocles/components/HtmlTooltip/HtmlTooltip';

export default HtmlTooltip;
